<template>
  <div class="createGallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>添加供应商
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">
          添加供应商
          <span style="color:#999">
            (带有
            <span style="color:red">*</span>的为必填选项)
          </span>
        </div>
      </div>
      <div class="table">
        <div class="form">
          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">
                  供应商名称:
                  <span style="color:red">*</span>
                </div>
              </el-col>
              <el-col :span="19">
                <div class="grid-content input">
                  <el-input v-model="form.name"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">供应商类型:</div>
              </el-col>
              <el-col :span="8">
                <el-select v-model="form.type" placeholder="请选择">
                  <el-option
                    v-for="item in tableData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
                <el-button @click="dialogVisible = true">编辑</el-button>
              </el-col>
              <el-col :span="3" style="margin-left:20px;">
                <div class="grid-content label">付款方式设置:</div>
              </el-col>
              <el-col :span="5">
                <el-select @change="choicePayType()" v-model="form.payType" placeholder="请选择">
                  <el-option v-for="item in payType" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-col>
              <el-col v-if="showInput" :span="3">
                <el-input v-model="replenish" :placeholder="replenishUnit"></el-input>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">
                  采购员:
                  <span style="color:red">*</span>
                </div>
              </el-col>
              <el-col :span="8">
                <el-input
                  placeholder="请选择采购员"
                  v-model="form.buyer"
                  :disabled="true"
                  class="input-with-select"
                >
                  <el-button @click="showBuyer()" slot="append" icon="el-icon-search"></el-button>
                </el-input>
              </el-col>
              <el-col :span="3" style="margin-left:20px;">
                <div class="grid-content label">电话:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.phone"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">所在国家:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.country"></el-input>
                </div>
              </el-col>
              <el-col :span="3" style="margin-left:20px;">
                <div class="grid-content label">所在省:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.province"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">所在市:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.city"></el-input>
                </div>
              </el-col>
              <el-col :span="3" style="margin-left:20px;">
                <div class="grid-content label">具体地址:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.address"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">网址:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.URL"></el-input>
                </div>
              </el-col>
              <el-col :span="3" style="margin-left:20px;">
                <div class="grid-content label">开户行:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.openingBank"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">邮政编码:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.postCode"></el-input>
                </div>
              </el-col>
              <el-col :span="3" style="margin-left:20px;">
                <div class="grid-content label">税号:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.dutyCode"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">法定代表人:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.legalPerson"></el-input>
                </div>
              </el-col>
              <el-col :span="3" style="margin-left:20px;">
                <div class="grid-content label">委托代理人:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.agent"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">共享人:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input v-model="form.sharePerson"></el-input>
                </div>
              </el-col>
              <el-col :span="3" style="margin-left:20px;">
                <div class="grid-content label">预设价格:</div>
              </el-col>
              <el-col :span="8">
                <el-select v-model="form.presetPrice" placeholder="请选择">
                  <el-option
                    v-for="item in presetPrice"
                    :key="item.id"
                    :label="item.value"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">单位抬头:</div>
              </el-col>
              <el-col :span="8">
                <el-select v-model="form.companyHead" placeholder="请选择">
                  <el-option v-for="item in companyHead" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-col>
              <el-col :span="3" style="margin-left:20px;">
                <div class="grid-content label">发票类型:</div>
              </el-col>
              <el-col :span="8">
                <el-select v-model="form.invoiceType" placeholder="请选择">
                  <el-option v-for="item in invoiceType" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">税率:</div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content input">
                  <el-input placeholder="请输入内容" v-model="form.taxRate">
                    <template slot="append">%</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3" style="margin-left:20px;">
                <div class="grid-content label">对应客户:</div>
              </el-col>
              <el-col :span="8">
                <el-input
                  placeholder="请选择对应客户"
                  v-model="form.client"
                  :disabled="true"
                  class="input-with-select"
                >
                  <el-button @click="showClient()" slot="append" icon="el-icon-search"></el-button>
                </el-input>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">经营范围:</div>
              </el-col>
              <el-col :span="19">
                <div class="grid-content input">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="form.businessScope"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row">
            <el-row>
              <el-col :span="3">
                <div class="grid-content label">备注:</div>
              </el-col>
              <el-col :span="19">
                <div class="grid-content input">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="form.remark"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="row" align="center">
            <div class="grid-content input">
              <button class="button" @click="submit()">提交</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="供应商类型定义"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="row">
        <el-row>
          <el-col :span="2">
            <div class="grid-content label">
              排序:
              <span style="color:red">*</span>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content input">
              <el-input v-model="typeRow.sort"></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="row">
        <el-row>
          <el-col :span="2">
            <div class="grid-content label">
              名称:
              <span style="color:red">*</span>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content input">
              <el-input v-model="typeRow.name"></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="row">
        <el-row>
          <el-col :span="2">
            <div class="grid-content label">备注:</div>
          </el-col>
          <el-col :span="19">
            <div class="grid-content input">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入内容"
                v-model="typeRow.remark"
              ></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-button type="success" @click="typeAdd()">新增</el-button>
        <el-button type="danger" @click="typeRow = {}">清空</el-button>
        <el-button type="info" @click="dialogVisible = false">关闭</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="排序" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="名称" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini">编辑</el-button>
            <el-button size="mini" type="danger" @click="typeDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="请选择采购员" :visible.sync="isShowBuyer" width="30%" center>
      <el-tree :data="userList">
        <span class="custom-tree-node" slot-scope="{ node,data}">
          <span>{{ node.label }}</span>
          <el-button
            @click="choiceBuyer(data)"
            style="margin-left:20px"
            type="text"
            size="mini"
            v-if="!data.children "
          >确定</el-button>
        </span>
      </el-tree>

      <!-- @node-click="handleNodeClick" -->
    </el-dialog>
    <el-dialog title="请选择对应客户" :visible.sync="isShowClient" width="30%" center>
      <div class="row">
        <el-row>
          <el-col :span="4">
            <div class="grid-content label">客户名称:</div>
          </el-col>
          <el-col :span="16">
            <div class="grid-content input">
              <el-input v-model="client.remark_name"></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="row">
        <el-row>
          <el-col :span="4">
            <div class="grid-content label">客户编码:</div>
          </el-col>
          <el-col :span="16">
            <div class="grid-content input">
              <el-input v-model="client.mobile"></el-input>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="row">
        <el-row type="flex" justify="start">
          <el-col :span="5">
            <el-button type="danger" @click="client = {}">清空</el-button>
          </el-col>
          <el-col :span="5">
            <el-button type="primary">搜索</el-button>
          </el-col>
        </el-row>
      </div>

      <div class="row">
        <el-table :data="clientList" border style="width: 100%">
          <el-table-column label="备注名" width="180">
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="choice_client(scope.row.remark_name)"
              >{{ scope.row.remark_name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="客户编码" width="180">
            <template slot-scope="scope">{{scope.row.mobile}}</template>
          </el-table-column>
          <el-table-column label="绑定手机号">
            <template slot-scope="scope">{{scope.row.bind_mobile}}</template>
          </el-table-column>
        </el-table>
      </div>

      <!-- @node-click="handleNodeClick" -->
    </el-dialog>
  </div>
</template>
<script>
import $ from 'jquery'

export default {
  name: 'createGallery',
  data() {
    return { serve: this.$store.state.serve,
      client: {},
      clientList: [],
      isShowClient: false,
      userList: [],
      isShowBuyer: false,
      replenishUnit: '',
      showInput: false,
      replenish: '',
      typeRow: {},
      dialogVisible: false,
      name: '',
      info: '',
      image: null,
      username: this.$cookies.get('username'),
      token: this.$cookies.get('token'),
      serve: this.$store.state.serve,
      form: {
        payType: '款到发货',
        invoiceType: '增值税发票',
        presetPrice: '参考成本价'
      },
      invoiceType: ['增值税发票', '普通发票', '收据'],
      companyHead: ['业立生物科技(上海)股份有限公司', '其他'],
      presetPrice: [
        {
          id: 1,
          value: '参考成本价'
        },
        {
          id: 2,
          value: '一级批发商'
        },
        {
          id: 3,
          value: '二级批发商'
        },
        {
          id: 4,
          value: '三级批发商'
        },
        {
          id: 5,
          value: '四级批发商'
        },
        {
          id: 6,
          value: '五级批发商'
        },
        {
          id: 7,
          value: '六级批发商'
        },
        {
          id: 8,
          value: '七级批发商'
        }
      ],
      tableData: [
        {
          id: 1,
          sort: '1',
          name: '业立区域签约代理'
        },
        {
          id: 2,
          sort: '2',
          name: '全国总代理'
        },
        {
          id: 3,
          sort: '3',
          name: '区域独家代理'
        },
        {
          id: 4,
          sort: '4',
          name: '区域一级代理'
        },
        {
          id: 5,
          sort: '5',
          name: '国外直供'
        },
        {
          id: 6,
          sort: '6',
          name: '厂家直供零采'
        }
      ],
      payType: [
        '款到发货',
        '收到货后N天付款',
        '开票后N天付款',
        '每月固定日期付款',
        '其他方式'
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  created() {
    this.$store.state.topActiveId = 12
    this.$store.state.leftTitle = '供应商表'
  },
  mounted() {},
  methods: {
    choice_client(name) {
      this.isShowClient = false
      this.form.client = name
    },
    showClient() {
      this.isShowClient = true
      this.axios
        .get(this.serve + '/admin/getTrueUserList', {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          this.clientList = res.data
        })
    },
    choiceBuyer(data) {
      this.isShowBuyer = false
      this.form.buyer = data.label
    },
    showBuyer() {
      this.isShowBuyer = true
      this.axios
        .get(this.serve + '/admin/getAdminUser', {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          this.userList = res.data
        })
    },
    choicePayType() {
      let payType = this.form.payType
      if (payType == '款到发货') {
        this.showInput = false
      } else if (payType == '收到货后N天付款') {
        this.replenishUnit = '天'
        this.showInput = true
      } else if (payType == '开票后N天付款') {
        this.replenishUnit = '天'
        this.showInput = true
      } else if (payType == '每月固定日期付款') {
        this.replenishUnit = '日期'
        this.showInput = true
      } else if (payType == '其他方式') {
        this.replenishUnit = '方式'
        this.showInput = true
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    typeDelete(row) {
      let id = row.id
      for (let i in this.tableData) {
        if (this.tableData[i].id == id) {
          this.tableData.splice(i, 1)
        }
      }
    },
    typeAdd() {
      if (!this.typeRow.sort) {
        this.$message.error({
          message: '排序为必填选项',
          offset: 300
        })
        return
      }
      if (!this.typeRow.name) {
        this.$message.error({
          message: '名称为必填选项',
          offset: 300
        })
        return
      }
      let data = {}
      data = {
        sort: this.typeRow.sort,
        name: this.typeRow.name,
        remark: this.typeRow.remark
      }
      this.tableData.push(data)
      console.log(this.tableData)
    },
    getImage(e) {
      this.image = e.target.files[0]
    },
    submit() {
      var formData = this.form
      if (formData.payType == '款到发货') {
        formData.payTypeStr = '款到发货'
      } else if (formData.payType == '收到货后N天付款') {
        formData.payTypeStr = '收到货后' + this.replenish + '天付款'
      } else if (formData.payType == '开票后N天付款') {
        formData.payTypeStr = '开票后' + this.replenish + '天付款'
      } else if (formData.payType == '每月固定日期付款') {
        formData.payTypeStr = '每月固定' + this.replenish + '号付款'
      } else if (formData.payType == '其他方式') {
        formData.payTypeStr = this.replenish
      }

      var qs = require('qs')
      if (!formData.name || !formData.buyer) {
        this.$message({
          showClose: true,
          message: '请填写必填选项',
          type: 'error',
          offset: 300
        })
        return;
      }
      formData.token = this.token
      formData.username = this.username
      let config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      var that = this
       const loading = this.$loading({
        lock: true,
        text: '正在添加...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.axios
        .post(this.serve + '/admin/addSupplier', qs.stringify(formData), config)
        .then(function(res) {
          if (res.data.status == 'success') {
            loading.close()
            that.$message({
              showClose: true,
              message: '供应商添加成功',
              type: 'success',
              offset: 300
            })
          }else if(res.data.code == '403'){
              that.$message.error(res.data.msg);
          } else {
            loading.close()
          }
        })
    }
  }
}
</script>
<style lang="scss">
.createGallery {
  background: #f5f5f5;
  color: #333;
  min-height: 1100px;
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .input {
    width: 100%；;
  }
  textarea {
    height: 300px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 1000px;
    margin: 0 auto;
    padding: 20px 0;
  }
  .label {
    line-height: 40px;
  }
  .notice {
    font-size: 13px;
    color: #666;
  }
}
</style>